import { render, staticRenderFns } from "./GoodList.vue?vue&type=template&id=e5816882&scoped=true&"
import script from "./GoodList.vue?vue&type=script&lang=js&"
export * from "./GoodList.vue?vue&type=script&lang=js&"
import style0 from "./GoodList.vue?vue&type=style&index=0&id=e5816882&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5816882",
  null
  
)

export default component.exports